"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var linear_1 = require("../../helper/easing/linear");
var window_event_1 = require("./window.event");
/**
 * Wrap the window object
 */
var BrowserWindow = /** @class */ (function () {
    /**
     * Create instance of BrowserWindow
     *
     * @param eventEmitter
     * @param window
     */
    function BrowserWindow(eventEmitter, window) {
        var _this = this;
        this.eventEmitter = eventEmitter;
        this.window = window;
        /**
         * Frames per second
         */
        this.fps = 60;
        /**
         * Duration of frame in millisecond
         */
        this.frameMs = (1 / this.fps) * 1000;
        /**
         * Window inner height
         */
        this.innerHeight = null;
        /**
         * Window inner width
         */
        this.innerWidth = null;
        /**
         * Emit an event when the window loads
         */
        this.onLoadWindow = function () {
            _this.getEventEmitter().emit(window_event_1.BrowserWindowEvent.load);
        };
        /**
         * Emit an event when the window resizes
         */
        this.onResizeWindow = function () {
            _this.setInnerHeight();
            _this.setInnerWidth();
            _this.getEventEmitter().emit(window_event_1.BrowserWindowEvent.resize);
        };
        /**
         * Emit an event when the window scrolls
         */
        this.onScrollWindow = function () {
            _this.getEventEmitter().emit(window_event_1.BrowserWindowEvent.scroll);
        };
        /**
         * Emit an event when the window's history changes
         */
        this.onPopstateWindow = function () {
            _this.getEventEmitter().emit(window_event_1.BrowserWindowEvent.popstate);
        };
        /**
         * Emit an event when the window's keyup event fires
         */
        this.onKeyupWindow = function (e) {
            _this.getEventEmitter().emit(window_event_1.BrowserWindowEvent.keyup, e);
        };
        /**
         * Emit an event when the window's keydown event fires
         */
        this.onKeydownWindow = function (e) {
            _this.getEventEmitter().emit(window_event_1.BrowserWindowEvent.keydown, e);
        };
        /**
         * Emit an event when the window's click event fires
         */
        this.onClickWindow = function (e) {
            _this.getEventEmitter().emit(window_event_1.BrowserWindowEvent.click, e);
        };
        this.observers();
    }
    /**
     * @inheritDoc
     */
    BrowserWindow.prototype.observers = function () {
        this.window.addEventListener(window_event_1.BrowserWindowEvent.load, this.onLoadWindow);
        this.window.addEventListener(window_event_1.BrowserWindowEvent.resize, this.onResizeWindow);
        this.window.addEventListener(window_event_1.BrowserWindowEvent.scroll, this.onScrollWindow);
        this.window.addEventListener(window_event_1.BrowserWindowEvent.popstate, this.onPopstateWindow);
        this.window.addEventListener(window_event_1.BrowserWindowEvent.keyup, this.onKeyupWindow);
        this.window.addEventListener(window_event_1.BrowserWindowEvent.keydown, this.onKeydownWindow);
        this.window.addEventListener(window_event_1.BrowserWindowEvent.click, this.onClickWindow);
    };
    /**
     * @inheritDoc
     */
    BrowserWindow.prototype.getNative = function () {
        return this.window;
    };
    /**
     * @inheritdoc
     */
    BrowserWindow.prototype.getScrollTop = function () {
        return this.window.scrollY || this.window.pageYOffset || this.window.document.documentElement.scrollTop;
    };
    /**
     * @inheritDoc
     */
    BrowserWindow.prototype.setTimeout = function (fn, delay) {
        return this.window.setTimeout(fn, delay);
    };
    /**
     * @inheritDoc
     */
    BrowserWindow.prototype.getEventEmitter = function () {
        return this.eventEmitter;
    };
    /**
     * @inheritdoc
     */
    BrowserWindow.prototype.getInnerHeight = function () {
        if (!this.innerHeight) {
            this.setInnerHeight();
        }
        return this.innerHeight;
    };
    /**
     * @inheritdoc
     */
    BrowserWindow.prototype.getInnerWidth = function () {
        if (!this.innerWidth) {
            this.setInnerWidth();
        }
        return this.innerWidth;
    };
    /**
     * @inheritDoc
     */
    BrowserWindow.prototype.scrollToY = function (position, duration, easing) {
        if (position === void 0) { position = 0; }
        if (duration === void 0) { duration = 2000; }
        if (easing === void 0) { easing = linear_1.easingLinear; }
        var scrollY = this.window.scrollY || this.window.pageYOffset || this.window.document.documentElement.scrollTop;
        var currentTime = 0;
        if (position === scrollY) {
            return;
        }
        this.updateScrollToY(position, duration, easing, currentTime);
    };
    /**
     * Sets window inner height
     */
    BrowserWindow.prototype.setInnerHeight = function () {
        this.innerHeight = this.getNative().innerHeight;
    };
    /**
     * Sets window inner width
     */
    BrowserWindow.prototype.setInnerWidth = function () {
        this.innerWidth = this.getNative().innerWidth;
    };
    /**
     * Update scrollToY, update a position of the scrollY
     * @param position
     * @param duration
     * @param easing
     * @param currentTime
     */
    BrowserWindow.prototype.updateScrollToY = function (position, duration, easing, currentTime) {
        var _this = this;
        currentTime += this.frameMs;
        var currentPosition = currentTime / duration;
        var transitionPosition = easing(currentPosition);
        var scrollY = this.window.scrollY || this.window.pageYOffset || this.window.document.documentElement.scrollTop;
        this.window.scrollTo(0, scrollY + (position - scrollY) * transitionPosition);
        if (currentPosition < 1) {
            this.window.requestAnimationFrame(function () {
                _this.updateScrollToY(position, duration, easing, currentTime);
            });
        }
    };
    return BrowserWindow;
}());
exports.BrowserWindow = BrowserWindow;
//# sourceMappingURL=window.js.map